import React, {useEffect, useState} from 'react';
import Prismic from '@prismicio/client';
import './VisitingScholars.css';

const VisitingScholars = ({client}) => {

    const [doc, setDoc] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await client.query(
                Prismic.Predicates.at('document.type', 'visiting_scholars'), {orderings : '[my.visiting_scholars.date_start desc]', pageSize: 100}
            )
            if (response) {
                setDoc(response.results);
            }
            }
            fetchData()
    }, [client]);
    if(doc.length > 0){
        return (
            <div className="Visiting-Scholars">
                <h2>Visiting Scholars</h2>
                <div className="visiting-scholars">
                {doc.map(d => (
                    <div key={d.id} className="visiting-scholar">
                        <div className="image"><img src={d.data.image.url} alt={d.data.name}/></div>
                        <div className="details">
                            <h2 className="name">{d.data.name}</h2>
                            <span className="title">{d.data.title}</span>
                            <span className="subtitle">{d.data.subtitle}</span>
                        </div>
                    </div>
                ))}
                </div>
            </div>
        )
    } else {
        return <div className="Visiting-Scholars">Loading...</div>;
    }
    
};
export default VisitingScholars;